module.exports = __webpack_public_path__ + "img/iphone@2x.a9a34e10.png";